import axios from 'axios'
import {helper} from "./helper";
import {router} from "./router";
import AWN from "awesome-notifications";
import "awesome-notifications/dist/style.css";
import {reportFailure, reportSuccess} from "./connectivity";

export const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: process.env.VUE_APP_HTTP_TIMEOUT
});

axiosInstance.interceptors.request.use(function (request) {
    if (helper.ls.get('user')) {
        request.headers = {'Authorization': 'Bearer ' + helper.ls.get('user').token};
    }
    return request
}, function (error) {
    if (process.env.VUE_APP_DEBUG_HTTP === 'true') {
        console.log(
            '>>>', error
        )
    }
    return Promise.reject(error)
});

axiosInstance.interceptors.response.use(function (response) {
    const request = response.config;
    if (process.env.VUE_APP_DEBUG_HTTP === 'true') {
        console.log(
            '>>>', request.method.toUpperCase(), request.url, request.params,
            '\n   ', response.status, response.data
        )
    }
    reportSuccess();
    return response
}, function (error) {
    let {response, config: request} = error;
    if (process.env.VUE_APP_DEBUG_HTTP === 'true') {
        if (request) {
            console.log(
                '>>>', request.method.toUpperCase(), request.url, request.params,
                '\n   ', response && response.status, response && response.data
            )
        }
    }
    // No response at all means the request never reached the server (network down, timeout,
    // CORS) - nothing below this depends on a response, so bail out early instead of throwing.
    if (!response) {
        reportFailure();
        return Promise.reject(error)
    }
    if (response.status === 401 || response.headers['token-expired']) {
        helper.ls.remove('user');
        router.push('/login');
    }
    if (response.status === 500) {
        new AWN().alert(helper.showError(error));
    }
    if (response.status >= 502 && response.status <= 504) {
        reportFailure();
    }
    return Promise.reject(error)
});

